import { useState } from "react";
import { API_URL } from "../../../utils/common";

export const useDeletePermisosPerfil = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const eliminarPermisoPerfil = async (
        idRelacion: number
    ): Promise<boolean> => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(

                `${API_URL}/cms/admin/perfiles/permisos/${idRelacion}`,

                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }

            );

            if (!response.ok) {

                const data = await response.json().catch(() => null);

                throw new Error(
                    data?.message ??
                    "Error al eliminar el permiso del perfil"
                );

            }

            return true;

        } catch (err: any) {

            console.error(err);

            setError(
                err.message || "Ocurrió un error"
            );

            return false;

        } finally {

            setLoading(false);

        }

    };

    return {

        eliminarPermisoPerfil,
        loading,
        error,

    };

};